import React from 'react'

export default function Home() {
  return (
    <div className='home-text'>
        <h1>Welcome to the website!</h1>
    </div>
  );
}